var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 4.66602L6.77531 8.47631C7.21609 8.78486 7.43648 8.93913 7.67621 8.99889C7.88796 9.05167 8.10943 9.05167 8.32119 8.99889C8.56091 8.93913 8.7813 8.78486 9.22208 8.47631L14.6654 4.66602M4.53203 13.3327H11.4654C12.5855 13.3327 13.1455 13.3327 13.5733 13.1147C13.9497 12.9229 14.2556 12.617 14.4474 12.2407C14.6654 11.8128 14.6654 11.2528 14.6654 10.1327V5.86602C14.6654 4.74591 14.6654 4.18586 14.4474 3.75803C14.2556 3.38171 13.9497 3.07575 13.5733 2.884C13.1455 2.66602 12.5855 2.66602 11.4654 2.66602H4.53203C3.41193 2.66602 2.85187 2.66602 2.42405 2.884C2.04773 3.07575 1.74176 3.38171 1.55002 3.75803C1.33203 4.18586 1.33203 4.74591 1.33203 5.86602V10.1327C1.33203 11.2528 1.33203 11.8128 1.55002 12.2407C1.74176 12.617 2.04773 12.9229 2.42405 13.1147C2.85187 13.3327 3.41193 13.3327 4.53203 13.3327Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogo);
export default __webpack_public_path__ + "static/media/Mail-logo.962725aa3f892c418cd6f07fd9ff2d02.svg";
export { ForwardRef as ReactComponent };